// extracted by mini-css-extract-plugin
export default {"helplink":"S2_PaymentLanding_helplink__Zdgk7"};